'use strict';

var UserActionController = (function() {
    var currentUser = null;
    var statusField = $('#status-list');
    var usersListOnsite = $('#user-list-onsite');
    var userListApi = 'Users/GetReportableAgents/';
    var leadStatusApi = 'Leads/LeadsStatus/';
    var transferLeadsApi = 'Leads/Transfer/';
    var transferUserId = null;
    var systemNameApi = 'PMSystem/Settings/';
    var systemTransferApi = 'PMSystem/LeadInsert/';

    var loadLeadList = function(usersListElement) {
        lead2lease.network.api.v1.users.getReportableAgents.get(lead2lease.session.activePropertyId, function(error, data) {
            if(error) {
                console.error(error);
            }
            else {
                buildUIList(usersListElement, data.Data);
            }
        });
    };

    var transferLeads = function(toUser, leadList, callback) {
        transferUserId = toUser;
        request('put', transferLeadsApi, JSON.stringify(leadList), function(status) {
            if(typeof callback == 'function' || status == null) {
                callback('success');
                return;
            }
            else {
                callback('error');
                return;
            }
        });
    };

    var transferLeadSystem = function(toUser, leadList, callback) {
        transferUserId = toUser;
        request('put', systemTransferApi, JSON.stringify(leadList), function(status) {
            if(typeof callback == 'function' || status == null) {
                callback('success');
                return;
            }
            else {
                callback('error');
                return;
            }
        });
    };

    var getPropertyId = function() {
        return lead2lease.session.activePropertyId;
    };
    var convertLeadStatus = function(leadList, callback) {
        var obj = {
            Data: leadList,
            Total: leadList.length
        };

        request('post', leadStatusApi, JSON.stringify(obj), function(status) {
            if(typeof callback == 'function' || status == null) {
                callback('success');
                return;
            }
            else {
                callback('error');
                return;
            }
        });
    };

    var buildUIList = function(element, list) {
        list.forEach(function(item) {
            var opt = $('<option></option>').attr('value', item.UserId).attr('data-name', item.FullName).text(item.FullName);
            if(item.UserId === lead2lease.session.user.userId) {
                opt.prop('selected', true);
            }
            $(element).append(opt);
        });
    };

    var request = function(type, endpoint, data, callback) {
        var params = {
            id: getPropertyId()
        };
        if(endpoint.indexOf('Transfer') > -1 || endpoint.indexOf('LeadInsert') > -1) {
            params.transferUserId = transferUserId;
        }

        lead2lease.network.request('api', type, 'v1/' + endpoint, params, data, function(error, data) {
            if(error != null) {
                console.log(error);
            }
            else {
                var successObj = null;

                if(data.responseText) {
                    try {
                        successObj = JSON.parse(data.responseText);
                    }
                    catch(e) {}
                }

                callback(successObj);
            }
        });
    };

    return {
        loadLeadList: loadLeadList,
        convertLeadStatus: convertLeadStatus,
        transferLeads: transferLeads,
        transferLeadSystem: transferLeadSystem
    };
})();
